export const title = 'Как предоставить доступ?';
